<template>
    <div class="imageBanner" >
        <div class="banner" :style="[{'padding': '0 ' + item.lrEdge.val + 'px'},{'margin-top': item.mbConfig.val +'px'},
            {'backgroundImage': item.bgColorImg.url ? 'url(' + item.bgColorImg.url + ')' : 'none'},
            {'background': item.bgColorImg.color[0].item}]">
            <div class="imgBox" v-for="(items,indexs) in item.menuConfig.list" :key="indexs" :class="{'border-radius': item.bgStyle.type === 1}"
                :style="'height: ' + item.height.val + 'px; margin-left:' + item.lrConfig.val + 'px;'"
            >
                <img v-if="item.menuConfig.list.length > 0" :src="items.img">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        item:{
            type:Object,
            default:{}
        }
    },
    created() {
        // 组件添加配置兼容调整
        if(!this.item.lrConfig){
            this.item.lrConfig = {
                title: "左右间距",
                val: 10,
                min: 0
            }
        }

        if(!this.item.bgColorImg){
            this.item.bgColorImg = {
                title: '背景设置',
                name: 'bgColor',
                url: '',
                default: [
                    {
                        item: '#fff'
                    }
                ],
                color: [
                    {
                        item: '#fff'
                    }
                ]
            }
        }
    },
    data(){
        return{
        }
    }
}
</script>

<style scoped lang="scss">
.imageBanner{
    .banner{
        width: 100%;
        vertical-align: bottom;
        display: flex;
        flex-wrap: nowrap;
        flex-direction: row;
        background-repeat: no-repeat !important;
        background-size: 100% 100% !important;

        .imgBox{
            flex: 1;
            img{
                width: 100%;
                height: 100% ;
            }
            &:first-child{
                margin-left: 0px !important;
            }
        }
    }

    .border-radius{
        border-radius: 6px;
        overflow: hidden;
    }
}
</style>